import React, { useState } from 'react';

import { useParams } from "react-router-dom";
import EmptyList from '../useful/EmptyList';
import { withAuthorization } from '../session';
import PlayerListForm from './PlayerListForm';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PlayerListItem from './PlayerListItem';
import TeamListLoader from '../loaders/TeamListLoader';
import ModalInfo from '../useful/ModalInfo';
import ModalForm from '../useful/ModalForm';

const PlayerList = (props) => {


    const { loading, players } = props;
    const playerUidList = players.map(item => item.uid)

    const [modal, setModal] = useState({ show: false, title: '', message: '' });

    const [playerForm, setPlayerForm] = useState({ show: false, player: {} });

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const showPlayerForm = (player) => {
        setPlayerForm({ show: true, player: player });
    }

    const tableHead =
        <thead className="">
            <tr >
                {/* <th className="align-middle text-center" style={{ width: '25px' }} >#</th> */}
                <th className="text-center" style={{ width: 32 }}>#</th>
                <th className="pl-0" >NOMBRE</th>
                <th className="text-center d-none d-md-table-cell" style={{ width: 77 }}>DNI</th>
                <th className="text-center" style={{ width: 25.5 }}>
                    <span className="d-none d-sm-table-cell">POSICIÓN</span>
                    <span className="d-table-cell d-sm-none">POS</span>
                </th>
                <th className="text-center" style={{ width: 40 }}></th>
            </tr>
        </thead>

    const loadindList = [1, 2, 3, 4].map((_item, i) => {
        return (
            <TeamListLoader key={i} index={i} />
        )
    })
    const loadingView =
        <table className="table table-sm table-hover small ">
            {tableHead}
            <tbody>
                {loadindList}
            </tbody>
        </table>

    const playersList = (players && players.length > 0) ?
        players.sort((pA, pB) => {
            let a = 10, b = 10;
            if (pA.position == "Director Técnico") a = 0;
            if (pB.position == "Director Técnico") b = 0;
            if (pA.position == "Arquero") a = 1;
            if (pB.position == "Arquero") b = 1;
            if (pA.position == "Defensa") a = 2;
            if (pB.position == "Defensa") b = 2;
            if (pA.position == "Medio") a = 3;
            if (pB.position == "Medio") b = 3;
            if (pA.position == "Ataque") a = 4;
            if (pB.position == "Ataque") b = 4;

            return (a - b) || pA.name.localeCompare(pB.name);
        })
        :
        [];

    const listView = (playersList && playersList.length > 0) ?
        players.map((item, i) => {
            if (item)
                return (
                    <PlayerListItem key={i} showModal={showModal} playerUidList={playerUidList} item={item} showPlayerForm={showPlayerForm} />
                )
        })
        :
        <tr>
            <td colSpan="10"><EmptyList /></td>
        </tr>

    let countText = "";
    if (!loading && players) {
        const playerCount = (players.length || "0");
        countText = ": " + playerCount;
    }

    return (
        <div className="">
            <div className="row justify-content-between m-0 mb-2 small">
                <span className="col-auto align-self-center font-weight-bolder m-0 p-0">
                    Jugadores{countText}
                </span>

                <button onClick={() => setPlayerForm({ show: true, player: {} })} className="btn btn-light btn-sm col-auto" type="button" >
                    <FontAwesomeIcon className="mr-2" icon={faPlus} />
                    Añadir Jugador
                </button>
            </div>

            <div className="table-responsive-sm">
                {(!loading) ?

                    <table className="table table-sm small ">
                        {tableHead}
                        <tbody>
                            {listView}
                        </tbody>
                    </table>
                    :
                    <div className="row m-0">
                        {loadingView}
                    </div>
                }
            </div>

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />

            <ModalForm
                show={playerForm.show}
                onClose={() => setPlayerForm({ show: false, player: {} })}
            >
                <PlayerListForm player={playerForm.player} playerUidList={playerUidList}
                    showModal={showModal} isOpen={playerForm.show}
                    onClose={() => setPlayerForm({ show: false, player: {} })} />
            </ModalForm>

        </div>
    )
}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin || authUser.token.premium;
    } else
        return false;
};
export default withAuthorization(condition)(PlayerList);